<template>
	<tbody :key="'subcontract_body_' + itemType + '_' + item.item_id" :class="{'single-blocked-content-cost-table': getBlockedItemsClass(subcontract)}" :style="{'opacity': subcontract.type === 'anulated' ? 0.5 : 1}">
		<tr>
			<!-- Primera columna: Info del item -->
			<td style="vertical-align: middle;min-width: 240px;padding-left: 30px!important;" :width="colWidths[0]" class="text-left pr-2">
				<div class="d-flex align-start justify-space-between my-1">
					<div style="width: 350px;" class="mb-1 pl-2" :ref="`line_element${index}`">
						<div class="d-flex align-center mb-1">
							<v-chip
								:color="getItemColor()"
								text-color="white"
								label
								small
								style="width: 160px;"
								class="px-2 d-flex justify-center">
								<p class="mb-0">{{ getItemChipLabel() }}</p>
							</v-chip>
							<v-chip
								color="warning"
								text-color="white"
								label
								small
								v-if="subcontractSigned(subcontract)"
								class="ml-2 px-2">
								<p class="mb-0 font-weight-bold">Subcontrato Cerrado</p>
							</v-chip>
						</div>
						<p class="mb-0 caption font-weight-bold text--disabled" v-m2-span>{{ getItemTitle() }}</p>
						<p class="mb-0 font-weight-bold" v-html="getItemDescription()"></p>
						<p class="font-weight-bold caption mb-0">{{ getItemCode() }}</p>
					</div>
					<div v-if="subcontract.subcontract_info && !isSubcontractor">
						<ProjectAnnulationInfo
							:item_type="itemType"
							:item_id="item.item_id"
							:project="project"
						/>
						<v-tooltip bottom v-if="!subcontractSigned(subcontract)">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									color="#FF120B"
									small
									icon
									v-bind="attrs"
									v-on="on"
								@click="openRemoveConfirmation(item, itemType)"
								>
									<v-icon dark size="20">mdi-delete-outline</v-icon>
								</v-btn>
							</template>
							<span>Saca el proyecto del subcontrato actual para poder integrarlo a uno diferente</span>
						</v-tooltip>
					</div>
					<div v-else-if="!isSubcontractor">
						<ContractorSelection
							:item="item"
							:project="project"
							:main_contract="project.contract"
							:subcontracts_info="subcontractInfoLocal"
							:full_subcontracts_info="summarySubcontractInfo"
							@update:contractor="handleUpdateContractor"
							@update:subcontract="handleUpdateSubcontractor"/>
					</div>
				</div>
			</td>

			<!-- Segunda columna: Valor del contratista -->
			<td style="vertical-align: middle;" class="text-right" v-if="!isSubcontractor">
				<SubcontractorContractValueDisplay
					:costsTable="costsTable"
					:costTableInfo="item"
					:itemType="itemType"
					:summarySubcontractInfo="summarySubcontractInfo"
					:taxRate="summarySubcontractInfo.tax?.value"
					:subcontract="subcontract"
					:ufValue="ufValue"
				/>
			</td>

			<!-- Columna: Valor base -->
			<td style="vertical-align: middle;" v-if="checkIfSubcontractContract(subcontract)" class="px-0">
				<div v-if="isSubcontractor">
					<p class="mb-0 caption  font-weight-bold text-right">{{ item.cost_value_uf | toThousandFilter(2) }} UF</p>
					<p class="mb-0 caption  font-weight-bold text-right">${{ item.cost_value_clp | toThousandFilter }} CLP</p>
				</div>
				<div v-else-if="currency == 'uf'" class="pt-2">
					<v-text-field
						v-model="item.cost_value_uf"
						type="number"
						label="Monto (UF) *"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1 px-2"
						style="font-size: 14px;"
						:rules="getNonZeroRules()"
						@keydown.enter.prevent
						@keypress="onKeyPress"
						@input="sanitizeUF(item, getParentItemTotalValueMultiWithTaxMethod(getItems(), item.project_table?.tax, item.project_table?.uf_value?.uf_value))"
					></v-text-field>
					<p class="mb-0 mt-1 caption font-weight-bold text-right px-2">${{ item.cost_value_clp | toThousandFilter }} CLP</p>
					<div class="px-1" v-if="item.cost_value_uf == 0 || item.cost_value_uf === null || item.cost_value_uf === undefined">
						<p class="mb-0 mt-1" style="color: #FF120B; font-size: 10px; font-weight: bold; text-align: right;">⚠ Campo requerido</p>
						<p class="mb-0" style="color: #FF120B; font-size: 10px; text-align: right;">No puede ser 0</p>
					</div>
				</div>
				<div v-else class="pt-2">
					<v-text-field
						v-model="item.cost_value_clp"
						type="number"
						step="1"
						label="Monto (CLP) *"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1"
						style="font-size: 14px;"
						:rules="getNonZeroRules()"
						@keydown.enter.prevent
						@keypress="validateCLP"
						@input="sanitizeIntegerInput(item, getParentItemTotalValueMultiWithTaxMethod(getItems(), item.project_table?.tax, item.project_table?.uf_value?.uf_value))"
					></v-text-field>
					<p class="mb-0 mt-1 caption font-weight-bold text-right">{{ item.cost_value_uf | toThousandFilter(2) }} UF</p>
					<div class="px-1" v-if="item.cost_value_clp == 0 || item.cost_value_clp === null || item.cost_value_clp === undefined">
						<p class="mb-0 mt-1" style="color: #FF120B; font-size: 10px; font-weight: bold; text-align: right;">⚠ Campo requerido</p>
						<p class="mb-0" style="color: #FF120B; font-size: 10px; text-align: right;">No puede ser 0</p>
					</div>
				</div>
			</td>

			<!-- Columna: Impuesto -->
			<td v-if="checkIfSubcontractContract(subcontract)">
				<div>
					<p class="mb-0 caption font-weight-bold text-right">{{ getTaxFromValue(item.cost_value_uf, getTaxValueFromSubcontract(subcontract)) | toThousandFilter(2) }} UF</p>
					<p class="mb-0 caption font-weight-bold text-right">${{ getTaxFromValue(item.cost_value_clp, getTaxValueFromSubcontract(subcontract)) | toThousandFilter }} CLP</p>
					<p class="mb-0 text-right" style="font-size: 11px;">{{ getTaxValueFromSubcontract(subcontract).name }} {{ getTaxValueFromSubcontract(subcontract).value }}%</p>
				</div>
			</td>

			<!-- Columna: Total con impuesto -->
			<td v-if="checkIfSubcontractContract(subcontract)">
				<div>
					<p class="mb-0 caption font-weight-bold text-right">{{ getValueWithTax(item.cost_value_uf, getTaxValueFromSubcontract(subcontract)) | toThousandFilter(2) }} UF</p>
					<p class="mb-0 caption font-weight-bold text-right">${{ getValueWithTax(item.cost_value_clp, getTaxValueFromSubcontract(subcontract)) | toThousandFilter }} CLP</p>
				</div>
			</td>

			<!-- Columnas de pagos -->
			<template v-if="checkIfSubcontractContract(subcontract) && hasAnyPaymentConfiguredForItem(itemType, itemTypeId)">
				<td
					v-for="(costsPayment, indexP) in costsPayments"
					:key="'mpA_'+costsPayment.id"
					class="px-1"
					colspan="2"
					:rowspan="addAdditionalAmountId == (itemType + '_' + (itemTypeId)) ? 3:1"
					style="vertical-align: top;">
					<div v-if="getItemPaymentValue(costsPayment, itemType, itemTypeId)">
						<!-- <p class="mb-0 caption font-weight-bold">Subtotal para EP {{ getCorrelativeStageIndex(subcontract, indexP) }}</p> -->
						<p class="mb-0 caption font-weight-bold">Subtotal para EP{{ indexP + 1 }}</p>
						<div class="d-flex align-start justify-space-between px-1 py-2" style="border: 1px solid grey; border-radius: 5px;"
							v-if="
								getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id)">
							<div class="px-2">
								{{ getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id)?.amount || '' }}%
							</div>
							<div>
								<p class="text-right mb-0 caption font-weight-bold" >{{getPaymentSubtotalWithAdjustment(getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id), { uf: item.cost_value_uf, clp: item.cost_value_clp }, getTaxValueFromSubcontract(subcontract), itemType, itemTypeId, subcontract.subcontract?.id, indexP).uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 caption font-weight-bold" >${{getPaymentSubtotalWithAdjustment(getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id), { uf: item.cost_value_uf, clp: item.cost_value_clp }, getTaxValueFromSubcontract(subcontract), itemType, itemTypeId, subcontract.subcontract?.id, indexP).clp | toThousandFilter}} CLP</p>
							</div>
						</div>

						<v-divider class="my-1"></v-divider>
						<p class="mb-1 caption font-weight-bold">Pago en Cuotas</p>
						<div class="mb-2" v-if="!isSubcontractor">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										depressed
										color="grey"
										x-small
										block
										class="py-3"
										@click="startConfigSubpayments(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small>mdi-chart-gantt</v-icon>
										<p class="ml-2 mb-0 caption">Agregar Cuota</p>
									</v-btn>
								</template>
								<span>Agrega cuota al estado de pago</span>
							</v-tooltip>
						</div>
						<div v-if="getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id) && getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id).subpayments && getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id).subpayments.length > 0">
							<div v-for="(subpayment, index) in getCalculatedSubpayments(getPaymentValue(costsPayment, itemType, itemTypeId, subcontract.subcontract?.id), { uf: item.cost_value_uf, clp: item.cost_value_clp }, getTaxValueFromSubcontract(subcontract), itemType, itemTypeId, subcontract.subcontract?.id, indexP)" :key="'sub_' + subpayment.id">
								<v-divider class="my-2"></v-divider>
								<SubpaymentItemDisplay
									:subpayment="subpayment"
									:calculated-values="{ uf: subpayment.calculatedUf, clp: subpayment.calculatedClp }"
									:is-subcontractor="isSubcontractor"
									:item-type="itemType"
									:item-id="itemTypeId"
									:payment-index="index"
									:cost-payment-index="indexP"
									:subcontract="subcontract"
									:subcontract-id="subcontract.subcontract?.id"
									@update-amount="handleUpdateSubpaymentAmount"
									@update-title="handleUpdateSubpaymentTitle"
									@remove-subpayment="handleRemoveSubpayment"
								/>
							</div>
									<div
										v-if="getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id) < 100"
										class="payments-warning-box"
										role="alert"
										aria-live="assertive"
									>
										<v-icon small color="error">mdi-alert-circle</v-icon>
										<span>La suma de los pagos debe ser 100%</span>
									</div>
						</div>
					</div>
				</td>
			</template>
			<template v-else-if="checkIfSubcontractContract(subcontract)">
				<td :colspan="costsPayments.length * 2" class="px-2" style="vertical-align: top;">
					<div class="d-flex flex-column align-center justify-center" style="height: 100%;">
						<p class="mb-0 text-center caption">No hay pagos configurados en <b>Tabla Programación Pagos</b> para este proyecto</p>
						<v-btn
							depressed
							color="#FF120B"
							small
							dark
							@click="$router.replace( '#summary' )"
						>
							<p class="mb-0 ml-2 caption">Ir a sección Tabla Resumen / Programación Pagos</p>
						</v-btn>
					</div>
				</td>
			</template>

			<!-- Último total -->
			<td :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }" class="text-left pr-2"
				v-if="checkIfSubcontractContract(subcontract)">
				<div class="text-right">
					<p class="mb-0 font-weight-bold body-1">{{getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)}}%</p>
					<p  class="mb-0 font-weight-bold">{{ getValueWithTax(item.cost_value_uf, getTaxValueFromSubcontract(subcontract)) * getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)/100 | toThousandFilter(2)}} UF</p>
					<p  class="mb-0 font-weight-bold">${{ getValueWithTax(item.cost_value_clp, getTaxValueFromSubcontract(subcontract)) * getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)/100 | toThousandFilter}} CLP</p>
				</div>
			</td>
		</tr>

		<!-- Row adicional: Aporte Adicional -->
		<tr v-if="subcontract.type == 'active' && addAdditionalAmountId == (itemType + '_' + (itemTypeId))">
			<td>
				<div class="d-flex justify-end flex-column text-right py-2">
					<p class="mb-1 font-weight-bold">Aporte Adicional</p>
					<p class="mb-0 caption">Ingresa un monto que se adicionará al total disponible para este proyecto</p>
				</div>
			</td>
			<td>
				<div v-if="currency == 'uf'" class="pt-2">
					<v-text-field
						v-model="item.additional_cost_value_uf"
						type="number"
						label="Adicional (UF) *"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1"
						style="font-size: 14px;"
						:rules="getNonZeroRules()"
						@keydown.enter.prevent
						@keypress="onKeyPress"
						@input="sanitizeAdditionalUF(item, getParentItemTotalValueMultiWithTaxMethod(getItems(), item.project_table?.tax, item.project_table?.uf_value?.uf_value))"
					></v-text-field>
					<p class="mb-0 text-right mt-1"><b class="caption">CLP</b> ${{ item.additional_cost_value_clp | toThousandFilter }}</p>
					<p class="mb-0 mt-1 caption" style="color: #FF120B; font-weight: bold; text-align: right;">⚠ Campo requerido - No puede ser cero</p>
				</div>
				<div v-else class="pt-2">
					<v-text-field
						v-model="item.additional_cost_value_clp"
						type="number"
						step="1"
						label="Adicional (CLP) *"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1"
						style="font-size: 14px;"
						:rules="getNonZeroRules()"
						@keydown.enter.prevent
						@keypress="validateCLP"
						@input="sanitizeIntegerAdditionalInput(item, getParentItemTotalValueMultiWithTaxMethod(getItems(), item.project_table?.tax, item.project_table?.uf_value?.uf_value))"
					></v-text-field>
					<p class="mb-0 text-right mt-1"><b class="caption">UF</b> ${{ item.additional_cost_value_uf | toThousandFilter(2) }}</p>
					<p class="mb-0 mt-1 caption" style="color: #FF120B; font-weight: bold; text-align: right;">⚠ Campo requerido - No puede ser cero</p>
				</div>
			</td>
			<td>
				<p class="mb-0 caption  font-weight-bold text-right">{{ item.additional_cost_value_uf | toThousandFilter(2) }} UF</p>
				<p class="mb-0 caption  font-weight-bold text-right">${{ item.additional_cost_value_clp | toThousandFilter }} CLP</p>
			</td>
			<td>
				<p class="mb-0 caption  font-weight-bold text-right">{{ getTaxFromValue(item.additional_cost_value_uf, getTaxValueFromSubcontract(subcontract)) | toThousandFilter(2) }} UF</p>
				<p class="mb-0 caption  font-weight-bold text-right">${{ getTaxFromValue(item.additional_cost_value_clp, getTaxValueFromSubcontract(subcontract)) | toThousandFilter }} CLP</p>
				<p class="mb-0 text-right" style="font-size: 11px;">{{ getTaxValueFromSubcontract(subcontract).name }} {{ getTaxValueFromSubcontract(subcontract).value }}%</p>
			</td>
			<td>
				<p class="mb-0 caption  font-weight-bold text-right">{{ getValueWithTax(item.additional_cost_value_uf, getTaxValueFromSubcontract(subcontract)) | toThousandFilter(2) }} UF</p>
				<p class="mb-0 caption  font-weight-bold text-right">${{ getValueWithTax(item.additional_cost_value_clp, getTaxValueFromSubcontract(subcontract)) | toThousandFilter }} CLP</p>
			</td>
			<td :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }" class="text-left pr-2">
				<div class="text-right">
					<p class="mb-0 font-weight-bold body-1">{{getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)}}%</p>
					<p  class="mb-0 font-weight-bold">{{getValueWithTax(item.additional_cost_value_uf, getTaxValueFromSubcontract(subcontract)) * getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)/100 | toThousandFilter(2)}} UF</p>
					<p  class="mb-0 font-weight-bold">${{ getValueWithTax(item.additional_cost_value_clp, getTaxValueFromSubcontract(subcontract)) * getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)/100 | toThousandFilter}} CLP</p>
				</div>
			</td>
		</tr>

		<!-- Row: Total con Aporte Adicional -->
		<tr v-if="subcontract.type == 'active' && addAdditionalAmountId == (itemType + '_' + (itemTypeId))">
			<td colspan="2">
				<div class="text-right py-2">
					<p class="mb-0 font-weight-bold">Total</p>
					<p class="mb-0 caption">Con Aporte Adicional</p>
				</div>
			</td>
			<td>
				<p class="mb-0 caption  font-weight-bold text-right">{{ (Number(item.cost_value_uf) + Number(item.additional_cost_value_uf)) | toThousandFilter(2) }} UF</p>
				<p class="mb-0 caption  font-weight-bold text-right">${{ (Number(item.cost_value_clp) + Number(item.additional_cost_value_clp)) | toThousandFilter }} CLP</p>
			</td>
			<td>
				<p class="mb-0 caption  font-weight-bold text-right">{{ getTaxFromValue(Number(item.cost_value_uf) + Number(item.additional_cost_value_uf), getTaxValueFromSubcontract(subcontract)) | toThousandFilter(2) }} UF</p>
				<p class="mb-0 caption  font-weight-bold text-right">${{ getTaxFromValue(Number(item.cost_value_clp) + Number(item.additional_cost_value_clp), getTaxValueFromSubcontract(subcontract)) | toThousandFilter }} CLP</p>
			</td>
			<td>
				<p class="mb-0 caption  font-weight-bold text-right">{{ getValueWithTax(Number(item.cost_value_uf) + Number(item.additional_cost_value_uf), getTaxValueFromSubcontract(subcontract)) | toThousandFilter(2) }} UF</p>
				<p class="mb-0 caption  font-weight-bold text-right">${{ getValueWithTax(Number(item.cost_value_clp) + Number(item.additional_cost_value_clp), getTaxValueFromSubcontract(subcontract)) | toThousandFilter }} CLP</p>
			</td>
			<td :style="{ backgroundColor: subcontractConfigTableColor, color: calcFontColor(subcontractConfigTableColor) }" class="text-left pr-2">
				<div class="text-right py-2">
					<p class="mb-0 font-weight-bold body-1">{{getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)}}%</p>
					<p class="mb-0 font-weight-bold">
						{{
							(Number(item.cost_value_uf) +
							Number(item.additional_cost_value_uf)) *
							(1 + Number(getTaxValueFromSubcontract(subcontract) || 0) / 100) *
							getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)/100
								| toThousandFilter(2)
						}} UF
					</p>
					<p class="mb-0 font-weight-bold">
						{{
							(Number(item.cost_value_clp) +
							Number(item.additional_cost_value_clp)) *
							(1 + Number(getTaxValueFromSubcontract(subcontract) || 0) / 100) *
							getAllPaymentPercentValues(itemType, itemTypeId, subcontract.subcontract?.id)/100
								| toThousandFilter
						}} CLP
					</p>
				</div>
			</td>
		</tr>

		<!-- Row: Toggle Aporte Adicional -->
		<tr>
			<td class="pa-0" style="border: none;border-width: 0;height: auto;">
				<div class="d-flex align-center justify-end" v-if="subcontract.type == 'active' && hasAnulatedSubcontract(item)">
					<v-tooltip bottom v-if="!addAdditionalAmountId">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								color="warning"
								outlined
								small
								tile
								v-bind="attrs"
								v-on="on"
								class="rounded-lg rounded-t-0"
								@click="addAdditionalAmountId = itemType + '_' + (itemTypeId)"
							>
								<v-icon dark size="20">mdi-chevron-down</v-icon>
								<p class="mb-0">Aporte Adicional</p>
							</v-btn>
						</template>
						<span>Agrega un monto adicional a este proyecto</span>
					</v-tooltip>
					<v-tooltip bottom v-if="addAdditionalAmountId == (itemType + '_' + (itemTypeId))">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								color="error"
								outlined
								small
								tile
								v-bind="attrs"
								v-on="on"
								class="rounded-lg rounded-t-0"
								@click="addAdditionalAmountId = null"
							>
								<v-icon dark size="20">mdi-chevron-up</v-icon>
								<p class="mb-0">Aporte Adicional</p>
							</v-btn>
						</template>
						<span>Agrega un monto adicional a este proyecto</span>
					</v-tooltip>
				</div>
			</td>
			<td style="border: none;border-width: 0;height: auto;" colspan="100%"></td>
		</tr>
		<AcceptCancelModal
			:acceptRejectModal="showRemoveConfirmation"
			:acceptRejectModalData="{
				title: 'Eliminar del Subcontrato',
				content_a: 'Estas seguro de que deseas sacar este proyecto del subcontrato actual?',
				content_b: 'Podras integrarlo a uno diferente despues.'
			}"
			:closeModal="closeRemoveConfirmation"
		/>
	</tbody>
</template>

<script>
import { getParentItemTotalValueMultiWithTax } from '@/helpers/tablecostHelpers.js'
import SubpaymentItemDisplay from './SubpaymentItemDisplay.vue'
import ContractorSelection from './ContractorSelection.vue'
import SubcontractorContractValueDisplay from './SubcontractorContractValueDisplay.vue'
import ProjectAnnulationInfo from '@/components/Views/Projects/SettingsParts/ProjectAnnulationInfo'
import AcceptCancelModal from '@/components/Modals/General/AcceptCancelModal.vue'

export default {
	name: 'CostTableBodyRow',
	components: {
		SubpaymentItemDisplay,
		ContractorSelection,
		SubcontractorContractValueDisplay,
		ProjectAnnulationInfo,
		AcceptCancelModal
	},
	props: {
		item: {
			type: Object,
			required: true
		},
		itemType: {
			type: String,
			enum: ['cost_table', 'stage', 'specialty', 'reception'],
			required: true
		},
		subcontract: {
			type: Object,
			required: true
		},
		costsPayments: {
			type: Array,
			required: true
		},
		costsTable: {
			type: Object,
			required: true
		},
		summarySubcontractInfo: {
			type: Object,
			required: true
		},
		parentMethods: {
			type: Object,
			required: true
		},
		index: Number,
		subcontractIndex: Number,
		project: Object,
		colWidths: Array,
		ufValue: [String, Number],
		currency: String,
		isSubcontractor: Boolean,
		subcontractConfigTableColor: String,
		addAdditionalAmountId: String,
		requiredRule: Array
	},
	computed: {
		itemTypeId() {
			if(this.itemType === 'cost_table'){
				return this.item.project_table?.id;
			}
			if(this.itemType === 'stage'){
				return this.item.stage.id;
			}
			if(this.itemType === 'specialty'){
				return this.item.specialty.id;
			}
			if(this.itemType === 'reception'){
				return this.item.project_table?.reception.id;
			}
			return null;
		},
		subcontractInfoLocal() {
			if(this.itemType === 'cost_table'){
				return this.getSubcontractsInfoForMainProject(this.item) || this.costsTable.subcontracts_info;
			}
			return this.costsTable.subcontracts_info;
		},
		itemId() {
			return this.item.project_table?.id || this.item.id;
		}
	},
	data: () => ({
		showRemoveConfirmation: false,
		pendingRemoveItem: null,
		pendingRemoveItemType: null
	}),
	mounted(){
	},
	methods: {
		getNonZeroRules() {
			return [
				value => value !== null && value !== undefined && value !== '' || 'El monto es requerido',
				value => (value && Number(value) !== 0) || 'El monto no puede ser cero'
			];
		},
		getItemColor() {
			// if (this.itemType === 'cost_table') {
			// 	return this.item.project_table?.contract.addendum_index ? '#FF120B' : 'green';
			// }
			// return 'green';
			return this.item.project_table?.contract.addendum_index ? '#FF120B' : 'green';
		},
		getItemChipLabel() {
			return this.item.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General';
		},
		getItemTitle() {
			if (this.itemType === 'cost_table') {
				return this.getMainProjectTitle(this.item);
			} else if (this.itemType === 'stage') {
				return 'Posible Etapa';
			} else if (this.itemType === 'specialty') {
				return 'Especialidad';
			}
			return '';
		},
		getItemDescription() {
			if (this.itemType === 'cost_table') {
				return this.getMainProjectDescription(this.item);
			} else if (this.itemType === 'stage') {
				return this.item.stage?.stage?.name || '';
			} else if (this.itemType === 'specialty') {
				return this.item.specialty?.specialty?.name || '';
			} else if (this.itemType === 'reception') {
				return 'Recepción';
			}
			return '';
		},
		getItemCode() {
			return `${this.item.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: '} ${this.getProjectCode(this.item.project_table?.contract)}`;
		},
		getProjectCode(contract) {
			if(contract?.parent_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		getMainProjectDescription(cost_table){
			return cost_table?.project_table?.project_cost_info?.title || ''
		},
		getMainProjectTitle(cost_table){
      const parentName = cost_table?.project_table?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
      const categoryName = cost_table?.project_table?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
			const projectTypeName = cost_table?.project_table?.contract?.info?.project_type?.name
      
      if (parentName && categoryName) {
        return `${categoryName} | ${parentName} | ${projectTypeName}`;
      }
      return parentName || categoryName || '';
		},
		getItems() {
			if (this.itemType === 'cost_table' && this.item.project_table?.surfaces) {
				return [this.item.project_table, this.item.project_table.surfaces];
			}
			else if(this.itemType === 'stage'){
				return this.item.stage.items;
			}
			else if(this.itemType === 'specialty'){
				return [this.item.specialty, this.item.specialty.items];
			}
			else if(this.itemType === 'reception' && this.item.project_table?.reception){
				return [this.item.project_table?.reception];
			}
			return [this.item];
		},
		// Métodos que vienen del padre a través de parentMethods prop
		getTaxValueFromSubcontract(subcontract) {
			return this.parentMethods.getTaxValueFromSubcontract(subcontract);
		},
		getTaxFromValue(value, tax) {
			return this.parentMethods.getTaxFromValue(value, tax);
		},
		getValueWithTax(value, tax) {
			return this.parentMethods.getValueWithTax(value, tax);
		},
		getPaymentValue(...args) {
			return this.parentMethods.getPaymentValue(...args);
		},
		getItemPaymentValue(...args) {
			return this.parentMethods.getItemPaymentValue(...args);
		},
		getPaymentSubtotalWithAdjustment(...args) {
			return this.parentMethods.getPaymentSubtotalWithAdjustment(...args);
		},
		getCalculatedSubpayments(...args) {
			return this.parentMethods.getCalculatedSubpayments(...args);
		},
		hasAnyPaymentConfiguredForItem(...args) {
			return this.parentMethods.hasAnyPaymentConfiguredForItem(...args);
		},
		getAllPaymentPercentValues(...args) {
			return this.parentMethods.getAllPaymentPercentValues(...args);
		},
		checkIfSubcontractContract(subcontract) {
			return this.parentMethods.checkIfSubcontractContract(subcontract);
		},
		getBlockedItemsClass(subcontract) {
			return this.parentMethods.getBlockedItemsClass(subcontract);
		},
		subcontractSigned(subcontract) {
			return this.parentMethods.subcontractSigned(subcontract);
		},
		getCorrelativeStageIndex(subcontract, index) {
			return this.parentMethods.getCorrelativeStageIndex(subcontract, index);
		},
		startConfigSubpayments(...args) {
			this.parentMethods.startConfigSubpayments(...args);
		},
		removeItemFromSubcontract(...args) {
			this.parentMethods.removeItemFromSubcontract(...args);
		},
		handleUpdateContractor(...args) {
			this.$emit('update:contractor', ...args);
		},
		handleUpdateSubcontractor(...args) {
			this.$emit('update:subcontract', ...args);
		},
		handleUpdateSubpaymentAmount(...args) {
			this.$emit('update-amount', ...args);
		},
		handleUpdateSubpaymentTitle(...args) {
			this.$emit('update-title', ...args);
		},
		handleRemoveSubpayment(...args) {
			this.$emit('remove-subpayment', ...args);
		},
		getSubcontractsInfoForMainProject(item) {
			return this.parentMethods.getSubcontractsInfoForMainProject(item);
		},
		sanitizeUF(...args) {
			return this.parentMethods.sanitizeUF(...args);
		},
		sanitizeIntegerInput(...args) {
			return this.parentMethods.sanitizeIntegerInput(...args);
		},
		sanitizeAdditionalUF(...args) {
			return this.parentMethods.sanitizeAdditionalUF(...args);
		},
		sanitizeIntegerAdditionalInput(...args) {
			return this.parentMethods.sanitizeIntegerAdditionalInput(...args);
		},
		validateCLP(...args) {
			return this.parentMethods.validateCLP(...args);
		},
		onKeyPress(...args) {
			return this.parentMethods.onKeyPress(...args);
		},
		calcFontColor(bgColor) {
			return this.parentMethods.calcFontColor(bgColor);
		},
		hasAnulatedSubcontract(item) {
			return this.parentMethods.hasAnulatedSubcontract(item);
		},
		getParentItemTotalValueMultiWithTaxMethod(...args) {
			const values = getParentItemTotalValueMultiWithTax(...args);
			return values
		},
		openRemoveConfirmation(item, itemType) {
			this.pendingRemoveItem = item;
			this.pendingRemoveItemType = itemType;
			this.showRemoveConfirmation = true;
		},
		closeRemoveConfirmation(confirmed = false) {
			if (confirmed && this.pendingRemoveItem && this.pendingRemoveItemType) {
				this.removeItemFromSubcontract(this.pendingRemoveItem, this.pendingRemoveItemType);
			}
			this.showRemoveConfirmation = false;
			this.pendingRemoveItem = null;
			this.pendingRemoveItemType = null;
		}
	}
};
</script>

<style scoped>
.payments-warning-box {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 6px 8px;
	margin-top: 6px;
	background-color: rgba(255, 18, 11, 0.08);
	border: 1px solid #FF120B;
	border-radius: 4px;
	color: #FF120B;
	font-size: 11px;
	font-weight: 700;
	line-height: 1.3;
}
</style>
